import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const getPathName = (path) => {
    const pathMap = {
      '/': 'home',
      '/about': 'about',
      '/projects': 'projects',
      '/volunteer': 'volunteer',
      '/donate': 'donate',
      '/contact': 'contact'
    };
    return pathMap[path] || 'home';
  };

  const currentSection = getPathName(location.pathname);

  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      <div className="nav-brand" onClick={() => navigate('/')}>
        <img
          src={process.env.PUBLIC_URL + '/logo.png'}
          alt="Viveka Seva Trust"
          className="nav-logo"
        />
        <span className="nav-title">Viveka Seva Trust</span>
      </div>
      
      <ul className="nav-links">
        <li>
          <a 
            href="/#" 
            className={currentSection === 'home' ? 'active' : ''} 
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
            }}
          >
            Home
          </a>
        </li>
        <li>
          <a 
            href="/#" 
            className={currentSection === 'about' ? 'active' : ''} 
            onClick={(e) => {
              e.preventDefault();
              navigate('/about');
            }}
          >
            About
          </a>
        </li>
        <li>
          <a
            href="/#" 
            className={currentSection === 'projects' ? 'active' : ''} 
            onClick={(e) => {
              e.preventDefault();
              navigate('/projects');
            }}
          >
            Projects
          </a>
        </li>
        <li>
          <a 
            href="/#" 
            className={currentSection === 'volunteer' ? 'active' : ''} 
            onClick={(e) => {
              e.preventDefault();
              navigate('/volunteer');
            }}
          >
            Volunteer
          </a>
        </li>
        <li>
          <a 
            href="/#" 
            className={currentSection === 'donate' ? 'active' : ''} 
            onClick={(e) => {
              e.preventDefault();
              navigate('/donate');
            }}
          >
            Donate
          </a>
        </li>
        <li>
          <a 
            href="/#" 
            className={currentSection === 'contact' ? 'active' : ''} 
            onClick={(e) => {
              e.preventDefault();
              navigate('/contact');
            }}
          >
            Contact
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
